export default {
  title: 'Page not found',
  message: 'Sorry, the page could not be found',
  notFoundButton: 'Back to home page',
};
